<template>
  <div class="home-container page">
    <div class="home-top-bar">
      <span class="home_app_name">{{ $brand.name }}</span>
      <van-icon name="bar-chart-o" class="top-bar-icon" aria-hidden="true" />
    </div>

    <div class="home-scroll">
      <div class="banner" >
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <van-image class="banner_img" round src="/img/home/banner1.png">
            </van-image>
          </van-swipe-item>
          <van-swipe-item>
            <van-image class="banner_img" round src="/img/home/banner2.png">
            </van-image>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="notice-bar">
        <i class="van-icon van-icon-volume-o notice-icon"></i>
        <div class="notice-wrapper">
          <div class="notice-text">{{ noticeText }}</div>
        </div>
      </div>

      <div class="hot-game">
          <div class="hot-game-li" @click="toNotice()">
              <van-icon name="balance-o" class="home-action-icon" aria-hidden="true" />
          </div>
          <div class="hot-game-divider"></div>
          <div class="hot-game-li" @click="toNotice()">
              <van-icon name="bell" class="home-action-icon" aria-hidden="true" />
          </div>
          <div class="hot-game-divider"></div>
          <div class="hot-game-li" @click="toGameN()">
              <van-icon name="like-o" class="home-action-icon" aria-hidden="true" />
          </div>
          <div class="hot-game-divider"></div>
          <div class="hot-game-li" @click="showVipDialog">
              <van-icon name="vip-card" class="home-action-icon" aria-hidden="true" />
          </div>
      </div>


      <div class="home-body">

        <div v-if="home_body==1">
          <div style="font-size: 0.5rem; padding: 10px;">Popular advice</div>
          <div class="xuanfei" v-for="(item,index) in girlData" :key="index">
            <div class="right-div"><img :src="item.imgUrl"></div>
            <div class="left-div">
              <div style="display: flex; width: 100%; font-size: 10px;">
                  <div class="left-div-biaoqian">Certification</div>
                  <div class="left-div-biaoqian">Video authentication</div>
                  <div style="margin-left: 0.2rem; font-size: 0.3rem;">{{ item.serial }}</div>
              </div>
              <div class="tags-container">
                  <div class="tag-item" v-for="(val,i) in characterArr(item.character)" :key="i" :class="getColorClass(i)">{{ val }}</div>
              </div>
              <div>Voting Competition: <span class="movie-list-money">{{item.like}}</span></div>
              <div style="font-size: 12px; color: #666; margin-top: 3px;">Height:{{item.high}}cm round: {{item.round}} Serving the city:{{item.area}}</div>
              <div class="left-div-butn" @click="toHomeDetail(item)">I want to date her </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIP Dialog -->
    <van-dialog v-model="showDialog" :show-confirm-button="false" class="vip-dialog">
      <div class="dialog-content">
        <h3 class="dialog-title">Explanation</h3>
        <p class="dialog-text">Please contact the manager for the VIP application.</p>
        <van-button class="confirm-btn" @click="showDialog = false">Confirm</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
//import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  data() {
    return {
      loading: false,
      finished: false,
      home_body:1,
      notice: this.$t("index.loading"),
      noticeText: '',
      basicData:[],
      isLoading: false,
      showDialog: false,
      swiperOptions: {
        direction: 'horizontal', // 垂直滚动vertical
        slidesPerView: 'auto',
        loop: true, // 循环播放
        loopedSlides: 1,
        loopAdditionalSlides:1,
        speed:100, // 滑动速度
        autoplay:true,
      },
      itemSwiperOptions: {
        direction: 'vertical', // 垂直滚动vertical
        autoplay: {
          delay: 3000, // 自动播放的延迟时间为 2500 毫秒
          disableOnInteraction: true, // 用户交互后仍继续自动播放
          isableOnInteraction: true, // 确保交互后还能继续自动播放
        },
        loop: true, // 循环播放
        speed: 50, // 滑动速度
      },
      xdItemSwiperOptions: {
        direction: 'vertical', // 垂直滚动vertical
        autoplay: {
          delay: 3000, // 自动播放的延迟时间为 2500 毫秒
          disableOnInteraction: false, // 用户交互后仍继续自动播放
          isableOnInteraction: false, // 确保交互后还能继续自动播放
        },
        loop: true, // 循环播放
        speed: 50, // 滑动速度
      },
      items: [
        { id: 1, name: 'คุณอั๋น', phone: '086***5681', detail: 'นัดสำเร็จ...........' },
        { id: 2, name: 'คุณนัท', phone: '092***4845', detail: 'กำลังใช้บริการ...........' },
        { id: 3, name: 'คุณเติ้ล', phone: '081***5158', detail: 'นัดสำเร็จ..............' },
        { id: 4, name: 'คุณไปร์ท', phone: '092***7539', detail: 'กำลังใช้บริการ.......' },
        { id: 5, name: 'คุณคิง', phone: '089***8270', detail: 'นัดสำเร็จ...........' },
        { id: 6, name: 'คุณต่าย', phone: '095***0323', detail: 'กำลังใช้บริการ...........' },
        { id: 7, name: 'คุณไทย', phone: '093***6157', detail: 'นัดสำเร็จ..............' },
        { id: 8, name: 'คุณคิม', phone: '087***8810', detail: 'กำลังใช้บริการ........' },
        { id: 9, name: 'คุณเรด', phone: '098***5571', detail: 'นัดสำเร็จ...........' },
        { id: 10, name: 'คุณเก้ง', phone: '092***6031', detail: 'กำลังใช้บริการ...........' },
        { id: 11, name: 'คุณไทม์', phone: '080***9970', detail: 'นัดสำเร็จ..............' },
        { id: 12, name: 'คุณเเฟรงค์ ', phone: '087***2103', detail: 'กำลังใช้บริการ........' },
        { id: 13, name: 'คุณโบว์', phone: '098***9874', detail: 'นัดสำเร็จ...........' },
        { id: 14, name: 'คุณบอม', phone: '065***8069', detail: 'กำลังใช้บริการ...........' },
        { id: 15, name: 'คุณเเบงค์ ', phone: '081***8880', detail: 'นัดสำเร็จ..............' },
        { id: 16, name: 'คุณโจ', phone: '099***3201', detail: 'กำลังใช้บริการ...........' },
        { id: 17, name: 'คุณอาร์ท', phone: '092***0061', detail: 'นัดสำเร็จ...........' },
        { id: 18, name: 'คุณไอซ์', phone: '063***9931', detail: 'กำลังใช้บริการ...........' },
        { id: 19, name: 'คุณกล้า', phone: '082***1181', detail: 'นัดสำเร็จ..............' },
        { id: 20, name: 'คุณคิว', phone: '087***2087', detail: 'กำลังใช้บริการ........' },
        { id: 21, name: 'คุณใหม่', phone: '099***3003', detail: 'นัดสำเร็จ...........' },
        { id: 22, name: 'คุณเจ๋ง', phone: '089***0285', detail: 'กำลังใช้บริการ...........' },
        { id: 23, name: 'คุณหมี', phone: '091***4087', detail: 'นัดสำเร็จ..............' },
        { id: 24, name: 'คุณภูมิ', phone: '095***9742', detail: 'กำลังใช้บริการ........' },
        { id: 25, name: 'คุณกร', phone: '098***8756', detail: 'นัดสำเร็จ...........' },
        { id: 26, name: 'คุณนนท์', phone: '081***8809', detail: 'กำลังใช้บริการ...........' },
        { id: 27, name: 'คุณเกม', phone: '099***5874', detail: 'นัดสำเร็จ..............' },
        { id: 28, name: 'คุณโทน', phone: '082***9606', detail: 'กำลังใช้บริการ.......' },
        { id: 29, name: 'คุณเต๋า', phone: '086***8776', detail: 'นัดสำเร็จ...........' },
        { id: 30, name: 'คุณเเทน', phone: '095***4450', detail: 'กำลังใช้บริการ...........' },
        { id: 31, name: 'คุณปาย', phone: '089****3391', detail: 'นัดสำเร็จ..............' },
        { id: 32, name: 'คุณบาส', phone: '093***8368', detail: 'กำลังใช้บริการ.......' },
        { id: 33, name: 'คุณสิทธ์', phone: '065***5956', detail: 'นัดสำเร็จ...........' },
        { id: 34, name: 'คุณกบ', phone: '098****2406', detail: 'กำลังใช้บริการ...........' },
        { id: 35, name: 'คุณปิง', phone: '095***5420', detail: 'นัดสำเร็จ..............' },
        { id: 36, name: 'คุณกอร์ฟ', phone: '099***0979', detail: 'กำลังใช้บริการ......' },
        { id: 37, name: 'คุณเบียร์', phone: '093***4783', detail: 'นัดสำเร็จ...........' },
        { id: 38, name: 'คุณคอป', phone: '092***3088', detail: 'กำลังใช้บริการ...........' },
        { id: 39, name: 'คุณจ๊อบ', phone: '081***6697', detail: 'นัดสำเร็จ..............' },
        { id: 40, name: 'คุณอาร์ม', phone: '095***8111', detail: 'กำลังใช้บริการ........' },
        { id: 41, name: 'คุณซัน', phone: '086***5002', detail: 'นัดสำเร็จ...........' },
        { id: 42, name: 'คุณเป๋า', phone: '082***2078', detail: 'กำลังใช้บริการ...........' },
        { id: 43, name: 'คุณต๊ะ', phone: '095***0860', detail: 'นัดสำเร็จ..............' },
        { id: 44, name: 'คุณอู๋', phone: '063***8966', detail: 'กำลังใช้บริการ.......' },
        { id: 45, name: 'คุณหนึ่ง', phone: '096***5056', detail: 'นัดสำเร็จ...........' },
        { id: 46, name: 'คุณเอ', phone: '088***3485', detail: 'กำลังใช้บริการ...........' },
        { id: 47, name: 'คุณโรจน์', phone: '099****6660', detail: 'นัดสำเร็จ..............' },
        { id: 48, name: 'คุณถวิล', phone: '089***6596', detail: 'กำลังใช้บริการ......' },
        { id: 49, name: 'คุณสอง', phone: '081***0012', detail: 'นัดสำเร็จ...........' },
        { id: 50, name: 'คุณเท่', phone: '087***0212', detail: 'กำลังใช้บริการ...........' }
      ],
      xdItems: [
        { id: 1, name: 'คุณเก่ง', phone: '092***6500', detail: 'เพื่อนเเนะนำมาครับ สาวสวยมากครับ บริการถึงใจ' },
        { id: 2, name: 'คุณสอง', phone: '081***8801', detail: 'น้องนัดผมให้ไปหาที่บ้านไปเย็*น้องสักน้ำสองน้ำ  ผิวน้องคือดีมาก' },
        { id: 3, name: 'ุณต้า', phone: '086***2445', detail: 'เห็นเเค่รูปใจก็วูบวาปเเล้วครับ ไม่มีประสบการณ์ เเต่เร้าร่อนไม่ไหว อายุราวนี้เป็นสิ่งที่เด็ดจริงๆ' },
        { id: 4, name: 'คุณพจน์', phone: '096***5401', detail: 'ได้ทั้งเลีย ได้ทั้งแตกใน สุดยอดมากครับ' },
        { id: 5, name: 'คุณบอล', phone: '099***5656', detail: 'นมเเท้อย่างใหญ่ เเท้ทั้งตัว ข้างล่างอย่างเเน่น อย่างเสียวเลย' },
        { id: 6, name: 'คุณเบส', phone: '084***5020', detail: 'นัดโรงเเรมเเถวบ้านน้องมาหาเองเลย  เเตกปาก เเตกในได้หมดเลย' },
        { id: 7, name: 'คุณมอส', phone: '092***6997', detail: 'งานตกปกตัว จัดสดได้ด้วย ทำได้ทุกท่าเลย ถือว่าเด็ดมาก' },
        { id: 8, name: 'คุณบีส', phone: '062***8544', detail: 'ของเเทร่เลย  ขาวอวบ นมเป็นนม  เล่นเเตกไปหลายน้ำเลย' },
        { id: 9, name: 'คุณต้น', phone: '095***4863', detail: 'ไปรับน้องถึงห้องเลย  จัดห้องน้องเเล้วรับไปเที่ยวต่อ โดนน้องเย็..เดินเเทบไม่ไหวเลย' },
        { id: 10, name: 'คุณเสาร์ ', phone: '081***6720', detail: 'ดูดปากเเรกลิ้น  เย็.. นม  กระเเทกห...น้องอย่างฟิตทนไม่ใหวเเตกในไปหลายรอบเลย' },
        { id: 11, name: 'คุณนที ', phone: '092***8547', detail: 'น้องน่ารัก เอวดีมาก ขอบอกเลยติดใจมากๆครับ' },
        { id: 12, name: 'คุณแบงค์', phone: '098***2103', detail: 'น้องชอบให้ลงลิ้นก่อนเย็ดครับ อมเก่งเสียวมากครับ' },
        { id: 13, name: 'คุณนัท', phone: '098***1478', detail: 'น้องอมดีมากๆ เสียวจนแตกใส่ปาก น้องก็อมต่อ คืองานดีมากครับ ถูกใจ' },
        { id: 14, name: 'คุณทาม', phone: '098***2563', detail: 'น้องโยกจนน้องน้ำเยิ้ม น้องเสร็จแล้วให้ผมเลียต่อ ติดใจน้องมากต้องกลับมาหาอีกแน่นอนครับ！！' },
        { id: 15, name: 'คุณเติ้ล', phone: '098***7199', detail: 'เห้นรูปน้องแล้ว ตรงปกตามรีวิว ขาว เห็นแล้วขึ้นเลยครับผม' },
        { id: 16, name: 'คุณเก่ง', phone: '092***3621', detail: 'เด็ด น้องสู้ตายมากครับ เอากันสนุก ท่า 69 ผมต้องยกให้น้องเลย ดีย์' },
        { id: 17, name: 'คุณไท', phone: '098***5422', detail: 'น้องบริการดี พูดเพราะ ไม่หยิ่ง น่ารัก โดนไป2ที เพลียเลยทีเดียวครับ' },
        { id: 18, name: 'คุณต่าย', phone: '098***0056', detail: 'ถึงใจมากครับ น่ารัก เป็นกันเอง ลูบเล้าเก่ง เสียวไปหมด สุดยอดครับ' },
        { id: 19, name: 'คุณนัท', phone: '092***5214', detail: 'พี่ได้ปี้น้องแล้วบริการดีจับใจแต่พอเริ่มงานบนเตียงเท่านั้นแหละ เก่งจัด ตามใจ ให้ใส่ชุดนอนลื่นๆ จูบแลกกันเบาๆ' },
        { id: 20, name: 'คุณเต๋า', phone: '082***6008', detail: 'ูปร่าง/หน้าตา - ตรงตามปก9/10 หน้าตาเหมือนในรูปเดะ หุ่นกำลังดีตัวเล็ก ผิวขาวเหลือง นมเป็นนม ชอบมากๆ' },
        { id: 21, name: 'คุณเไอซ์', phone: '098***0001', detail: 'หุ่นสวยๆ นมขนาดใหญ่ บวกกับหน้าตาที่น่ารักของน้องอีกน้องควบม้าได้เก่งมาก ยั่วๆบดๆจนเราแตก ดีจริงๆ' },
        { id: 22, name: 'คุณคิมคิม', phone: '098***2322', detail: 'น้องยั่ว เราผลัดขึ้นไปเรื่อยๆ มันเสียวและโฟลว์ดีสุดๆ จบที่น้องขึ้นให้รอบสุดท้ายอย่างเฉียบ แตกเลย เด็ดขาดมาก' },
        { id: 23, name: 'คุณทีม', phone: '098***0141', detail: 'คนนี้สวยน่าตาดึงดูด นมสวย บริการเยี่ยมครับ เห็นหน้าแล้วทนไม่ไหวจริงๆจากเสร็จยากๆเจอจ้องตาไปต้องยอมแพ้พ่ายครับ ต้องมาลองชอบครับ' },
        { id: 24, name: 'คุณกอล์ฟ', phone: '098***1072', detail: 'น่ารักและเหมือนในภาพ เย้ายวนตั้งแต่วินาทีที่เดินเข้าห้องจนหมดเวลา บริการดี ดูแลดี ดูดเก่งมาก โดยส่วนตัวแล้วผมชอบผู้หญิงที่...ดูดเก่งอยู่แล้ว' },
        { id: 25, name: 'คุณอั้ม', phone: '097***8583', detail: 'ผิวขาว ทำตานิด ทำจมูกหน่อย ทำปากน้อยๆ ทำนมบึ้มๆ !! น้องอาบน้ำให้ เสียวมากอมสุดอมลึก น้องมีชุดตรีมเลือกได้หลายชุด งานดีย์' },
        { id: 26, name: 'คุณกล้า', phone: '096***1049', detail: 'น้องทำผมถูกใจมาก ผมจัดไป 3 ท่า เบสิก ท่าหมา จบด้วยน้องขึ้นให้ครับ งานตามใจนะครับชอบแบบไหนบอกน้องได้เลยครับ' },
        { id: 27, name: 'คุณเฟรน', phone: '098***5288', detail: 'น้องน่ารัก ครับ ตัวเล็กๆ ยิ้มเก่ง อมสด อาบน้ำให้ กูแลฟิวแฟนเลย ไม่ถือตัว ไม่ติดมือถือ แต่ติดผม เพราะผมเลียให้หมดครับ เด็ดมากๆ' },
        { id: 28, name: 'คุณโอ๊ค', phone: '066***9987', detail: 'น้องบอก จะเล็ก จะใหญ่ไม่ว่า แต่ลีลาต้องได้' },
        { id: 29, name: 'คุณเอก', phone: '094***7480', detail: 'นัดน้องมาสวิงกิ้งที่บ้านโครตมันส์เลยครับ' },
        { id: 30, name: 'คุณกันย์', phone: '063***0031', detail: 'น้องบอก 56 59 ก็เอาอยู่ จะเอาจนสำลักน้ำแตกแบบไม่ยั้ง' },
        { id: 31, name: 'คุณแก๊ป', phone: '084***1700', detail: 'นัดน้องๆไปเจอโรงแรม จะอมสด เลียไข่ ก็ได้หมด ขอแค่บอก น้องๆก็จัดให้' },
        { id: 32, name: 'คุณไพค์', phone: '091***6334', detail: 'เคยใช้บริการน้องผมสั้น ผมติดใจมาก จนต้องกลับมาใช้บริการอีก' },
        { id: 33, name: 'คุณแม็กซ์', phone: '099***2677', detail: 'เคยนัดน้องครั้งนึง หน้าตาดูซื่อๆ แต่เรื่องบนเตียงเด็ดสุดๆ' },
        { id: 34, name: 'คุณไนล์', phone: '087***8832', detail: 'ยังไม่ทันได้นัดเห็นแค่รูปก็แตกแล้ว ถ้าเจอตัวจริงจะขนาดไหนกัน' },
        { id: 35, name: 'คุณยอด', phone: '088***6816', detail: 'เจอน้องครั้งแรก สเปค ขอแบบจุกๆ ขอเท่าไหร่ก็ไม่เคยขัด' },
        { id: 36, name: 'คุณปาล์ม', phone: '074***4771', detail: 'นัดน้องมาเย็..บ้านเพื่อน น้องบอกขอแบบสุกี้รวมก็ได้ ผมก็เลยชวนเพื่อนมาแจมด้วย' },
        { id: 37, name: 'คุณปอนด์', phone: '084***8002', detail: 'เหงาๆไม่รู้จะทำอะไร จนได้มาใช้บริการกับเว็บนี้ บริการดีถึงใจสุดๆ สาวๆคือเด็ดๆทั้งนั้น' },
        { id: 38, name: 'คุณธีร์', phone: '095***3795', detail: 'น้องๆเว็บนี้น่ารักกันทุกคน ท่ายากก็เอาเรื่อง เอาสด แตกใน ได้หมด' },
        { id: 39, name: 'คุณแลนซ์', phone: '061***1672', detail: 'นัดน้องมามีอะไรกันที่บ้านแฟน ตอนแฟนไปทำงาน ทั้งน่าตื่นเต้น และก็เร้าใจมากครับ' },
        { id: 40, name: 'คุณแฟรงค์ ', phone: '092***5680', detail: 'ดูด เลีย อมสด แตกใน แถมล้างตู้เย็นให้อีกด้วย บอกเลยว่าฟินโครตๆ' },
        { id: 41, name: 'คุณทัพ', phone: '081***3091', detail: 'เพื่อนเคยมาใช้บริการเลยให้มาลองดู น้องเอวดีมาก ใส่ใจทุกรายละเอียดว่าเราจะชอบแบบไหน น้องก็จัดให้ทุกแบบเลยครับ' },
        { id: 42, name: 'คุณเบิร์ด', phone: '096***6929', detail: 'เว็บนี้สาวๆดีบริการถึงใจมาก มาใช้บริการกี่รอบก็ไม่ทำให้ผิดหวังเลยครับ' },
        { id: 43, name: 'คุณชล', phone: '065***1432', detail: 'ผมบอกชอบคนหื่นๆ เซ็กส์จัดๆ น้องก็จัดให้ผมทั้งคืนแบบไม่พักเลยครับ' },
        { id: 44, name: 'คุณแท่ง', phone: '097***4071', detail: 'ก่อนเจอน้องถ่ายภาพเซ็กซี่มาอวด ทำเอาผมอดใจไม่ไหวเลย' },
        { id: 45, name: 'คุณเฟิร์ส', phone: '085***4460', detail: 'เวลาได้ยัดน้องแล้วเสียงครางแบบเร้าใจผมมาก ชอบสุดๆเลยครับ' },
        { id: 46, name: 'คุณกอล์ฟ', phone: '085***1674', detail: 'หุ่นเอ็กซ์มาก นมเป็นนม เวลาน้องขึ้นให้แล้ว อธิบายไม่ถูกเลย' },
        { id: 47, name: 'คุณฟอร์ด', phone: '096***2932', detail: 'ตอนน้องโยก มันฟินสุดๆไปเลยครับ ยิ่งได้แตกในด้วย เอาใจผมไปเลยเต็มๆ' },
        { id: 48, name: 'คุณกัณต์', phone: '098***9682', detail: 'น้องคุยเก่งตลกเป็นกันเอง เฟรนลี่ดูแลดีที่สุดเท่าที่เคยเที่ยวมา ต้องมาลองครับ ประทับใจครับ' },
        { id: 49, name: 'คุณเบียร์', phone: '098***5417', detail: 'เซ็กซี่มาก อมเก่ง ช่วงล่างฟิตมาก เล่นได้ทุกท่าที่ขอ กลิ่นตัวหอมอ่อนๆ จุกสวยเล่นเพลินเลย ชอบ' },
        { id: 50, name: 'คุณโบว์', phone: '098***9682', detail: 'น้องเล้าโลมและอมเก่งจนผมต้องบอกพอแล้วเด๊ยวแตก ก็เลยให้น้องขึ้น น้องขึ้นเด็ดจริงๆ ขึ้นแบบเตียงแทบผมไม่ไหวเลยขอเปลี่ยนเป็นท่าขอบเตียง' }
      ],
      classOption() {
        //这里的计算属性需要绑定到上面的vue-seamless-scroll上
        return {
          step: -1, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: false, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: false, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
      // girlData:[
      //   {id:'1',code: "902***", serial: 'J52', name: 'Pam', character: 'Slim waist, petite body, sexy, cute', area: 'Rayong', high: '162', weight: '46', round: '87-69-89', browse: '124.6', like: '520', imgUrl: '/img/girl/1/1.png', detail1: '/img/girl/1/2.png', detail2: '/img/girl/1/3.png'},
      //   {id:'2',code: "601***", serial: 'J53', name: 'Nadear', character: 'Fair skin, natural breasts, cute, not arrogant', area: 'Ayutthaya', high: '162', weight: '48', round: '88-65-90', browse: '276.4', like: '876', imgUrl: '/img/girl/2/4.png', detail1: '/img/girl/2/5.png', detail2: '/img/girl/2/6.png'},
      //   {id:'3',code: "228***", serial: 'J54', name: 'Donut', character: 'Petite, cute, honest', area: 'Khon Kaen', high: '161', weight: '45', round: '86-64-88', browse: '774.6', like: '970', imgUrl: '/img/girl/3/7.png', detail1: '/img/girl/3/8.png', detail2: '/img/girl/3/9.png'},
      //   {id:'4',code: "885***", serial: 'J55', name: 'Minnie', character: 'Hot body, long hair, clingy', area: 'Phuket', high: '159', weight: '47', round: '90-66-91', browse: '996.1', like: '480', imgUrl: '/img/girl/4/10.png', detail1: '/img/girl/4/11.png', detail2: '/img/girl/4/12.png'},
      //   {id:'5',code: "652***", serial: 'J56', name: 'Puifai', character: 'Fair skin, cute, honest, good body', area: 'Bangkok', high: '158', weight: '44', round: '85-63-87', browse: '7462.2', like: '532', imgUrl: '/img/girl/5/13.png', detail1: '/img/girl/5/14.png', detail2: '/img/girl/5/15.png'},
      //   {id:'6',code: "634***", serial: 'J57', name: 'Khimkhim', character: 'Busty, fair skin, playful', area: 'Pathum Thani', high: '163', weight: '50', round: '92-67-90', browse: '455.6', like: '354', imgUrl: '/img/girl/6/16.png', detail1: '/img/girl/6/17.png', detail2: '/img/girl/6/18.png'},
      //   {id:'7',code: "976***", serial: 'J58', name: 'Pat', character: 'Good talker, fun, cute', area: 'Chonburi', high: '164', weight: '49', round: '89-65-91', browse: '857.3', like: '238', imgUrl: '/img/girl/7/19.png', detail1: '/img/girl/7/20.png', detail2: '/img/girl/7/21.png'},
      //   {id:'8',code: "865***", serial: 'J59', name: 'Ingfa', character: 'Clingy, attentive, very hot', area: 'Samut Prakan', high: '163', weight: '48', round: '88-64-89', browse: '746.1', like: '298', imgUrl: '/img/girl/8/22.png', detail1: '/img/girl/8/23.png', detail2: '/img/girl/8/24.png'},
      //   {id:'9',code: "276***", serial: 'J60', name: 'Fongbeer', character: 'Petite, easy to carry, good moves', area: 'Nonthaburi', high: '162', weight: '43', round: '84-62-86', browse: '83.3', like: '240', imgUrl: '/img/girl/9/25.png', detail1: '/img/girl/9/26.png', detail2: '/img/girl/9/27.png'},
      //   {id:'10',code: "3845***", serial: 'J61', name: 'Ice', character: 'Clingy, cute, attentive', area: 'Bangkok', high: '164', weight: '47', round: '87-65-88', browse: '962.1', like: '840', imgUrl: '/img/girl/10/28.png', detail1: '/img/girl/10/29.png', detail2: '/img/girl/10/30.png'},
      //   {id:'11',code: "459***", serial: 'J62', name: 'May', character: 'Good personality, clingy, attentive, not stubborn', area: 'Kamphaeng Phet', high: '162', weight: '46', round: '86-64-87', browse: '877.3', like: '900', imgUrl: '/img/girl/11/31.png', detail1: '/img/girl/11/32.png', detail2: '/img/girl/11/33.png'},
      //   {id:'12',code: "745***", serial: 'J63', name: 'Boom', character: 'Smiley, clingy, attentive, follow customer', area: 'Pattaya', high: '155', weight: '42', round: '85-63-86', browse: '766.3', like: '900', imgUrl: '/img/girl/12/34.png', detail1: '/img/girl/12/35.png', detail2: '/img/girl/12/36.png'},
      //   {id:'13',code: "576***", serial: 'J64', name: 'Bambam', character: 'Good personality, attentive, good talker', area: 'Buriram', high: '160', weight: '48', round: '88-66-89', browse: '6435.2', like: '900', imgUrl: '/img/girl/13/37.png', detail1: '/img/girl/13/38.png', detail2: '/img/girl/13/39.png'},
      //   {id:'14',code: "534***", serial: 'J65', name: 'Ice', character: 'Cute, good talker, smiley', area: 'Lopburi', high: '157', weight: '44', round: '84-62-85', browse: '265.3', like: '172.4', imgUrl: '/img/girl/14/40.png', detail1: '/img/girl/14/41.png', detail2: '/img/girl/14/42.png'},
      //   {id:'15',code: "353***", serial: 'J66', name: 'Pure', character: 'Cute, good personality, sweet talk, good service', area: 'Prachin Buri', high: '170', weight: '52', round: '90-68-92', browse: '967.3', like: '900', imgUrl: '/img/girl/15/43.png', detail1: '/img/girl/15/44.png', detail2: '/img/girl/15/45.png'},
      //   {id:'16',code: "657***", serial: 'J67', name: 'Palin', character: 'Good talker, friendly, playful', area: 'Chachoengsao', high: '156', weight: '43', round: '83-61-84', browse: '374.6', like: '900', imgUrl: '/img/girl/16/46.png', detail1: '/img/girl/16/47.png', detail2: '/img/girl/16/48.png'},
      //   {id:'17',code: "865***", serial: 'J68', name: 'Chinchin', character: 'Petite, very sexy, smooth fair skin, attentive', area: 'Phuket', high: '170', weight: '51', round: '91-67-93', browse: '726.3', like: '900', imgUrl: '/img/girl/17/49.png', detail1: '/img/girl/17/50.png', detail2: '/img/girl/17/51.png'},
      //   {id:'18',code: "583***", serial: 'J69', name: 'Poppy', character: 'Cute, fair, petite, busty', area: 'Pattaya', high: '166', weight: '50', round: '92-66-90', browse: '767.3', like: '900', imgUrl: '/img/girl/18/52.png', detail1: '/img/girl/18/53.png', detail2: '/img/girl/18/54.png'},
      //   {id:'19',code: "907***", serial: 'J70', name: 'Pam', character: 'Clingy, attentive, not stubborn, good service', area: 'Chiang Mai', high: '165', weight: '49', round: '88-65-89', browse: '345.1', like: '900', imgUrl: '/img/girl/19/56.png', detail1: '/img/girl/19/57.png', detail2: '/img/girl/19/58.png'},
      //   {id:'20',code: "237***", serial: 'J71', name: 'Pim', character: 'Beautiful fair skin, cute, good personality', area: 'Bangkok', high: '162', weight: '46', round: '87-64-88', browse: '943.2', like: '900', imgUrl: '/img/girl/20/59.png', detail1: '/img/girl/20/60.png', detail2: '/img/girl/20/61.png'},
      //   {id:'21',code: "342***", serial: 'J72', name: 'Lookchup', character: 'Beautiful, sexy, cute, adorable', area: 'Udon Thani', high: '157', weight: '45', round: '86-63-87', browse: '758.2', like: '900', imgUrl: '/img/girl/21/62.png', detail1: '/img/girl/21/63.png', detail2: '/img/girl/21/64.png'}
      // ],
      girlData:[
        {id:'1',code: "902***", serial: 'J52', name: 'Pam', character: 'Hugging, caressing, kissing, sucking, breast massage', area: 'Nevşehir', high: '159', weight: '46', round: '87', browse: '124.6', like: '800', imgUrl: '/img/girl/1/01.jpg', detail1: '/img/girl/1/01.jpg', detail2: '/img/girl/1/01.jpg'},
        {id:'2',code: "601***", serial: 'L53', name: 'Nadear', character: 'Wife, Abalone, Hot Dance', area: 'Gümüşhane', high: '163', weight: '48', round: '90', browse: '276.4', like: '500', imgUrl: '/img/girl/2/01.jpg', detail1: '/img/girl/2/01.jpg', detail2: '/img/girl/2/01.jpg'},
        {id:'3',code: "228***", serial: 'N54', name: 'Donut', character: 'Wife, Abalone, Hot Dance', area: 'Ankara', high: '160', weight: '45', round: '90', browse: '774.6', like: '3000', imgUrl: '/img/girl/3/01.jpg', detail1: '/img/girl/3/01.jpg', detail2: '/img/girl/3/01.jpg'},
        {id:'4',code: "885***", serial: 'G56', name: 'Minnie', character: 'Wife, Abalone, Hot Dance', area: 'Konya', high: '160', weight: '47', round: '88', browse: '996.1', like: '300', imgUrl: '/img/girl/4/01.jpg', detail1: '/img/girl/4/01.jpg', detail2: '/img/girl/4/01.jpg'},
        {id:'5',code: "652***", serial: 'C58', name: 'Puifai', character: 'Wife, abalone, hot dance', area: 'Elazığ', high: '167', weight: '44', round: '90', browse: '7462.2', like: '1000', imgUrl: '/img/girl/5/01.jpg', detail1: '/img/girl/5/02.jpg', detail2: '/img/girl/5/01.jpg'},
        {id:'6',code: "634***", serial: 'N59', name: 'Khimkhim', character: 'Wife, Abalone, Hot Dance', area: 'Afyonkarahisar', high: '156', weight: '50', round: '88', browse: '455.6', like: '2000', imgUrl: '/img/girl/6/01.jpg', detail1: '/img/girl/6/02.jpg', detail2: '/img/girl/6/03.jpg'},
        {id:'7',code: "976***", serial: 'F61', name: 'Pat', character: 'Masturbation, Oral Sex, Full Body Licking', area: 'İstanbul', high: '165', weight: '49', round: '88', browse: '857.3', like: '800', imgUrl: '/img/girl/7/01.jpg', detail1: '/img/girl/7/02.jpg', detail2: '/img/girl/7/03.jpg'},
        {id:'8',code: "865***", serial: 'M62', name: 'Ingfa', character: 'Student, Abalone, Hot Dance', area: 'Çanakkale', high: '162', weight: '48', round: '89', browse: '746.1', like: '500', imgUrl: '/img/girl/8/01.jpg', detail1: '/img/girl/8/02.jpg', detail2: '/img/girl/8/03.jpg'},
        {id:'9',code: "276***", serial: 'O63', name: 'Fongbeer', character: 'Oralsex, 69, Lippenkuss', area: 'Sakarya', high: '162', weight: '43', round: '84', browse: '83.3', like: '450', imgUrl: '/img/girl/9/01.jpg', detail1: '/img/girl/9/02.jpg', detail2: '/img/girl/9/03.jpg'}
      ]
    };
  },
  components: {
    //vueSeamlessScroll
  },
  mounted () {
  },
  methods:{
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t("reservation.refresh"));
      }, 500);
    },
    getBasicConfig(){
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res=>{
        this.basicData = res.data;
		console.log(res.data);
        this.getNotice(this.basicData);//获取公告
        // this.getBanner(this.basicData);//获取banner
      })

    },
    characterArr(str){
      return str.split(',')
    },
    getColorClass(index) {
      // 定义三种颜色类：红色、黄色、蓝色
      const colorClasses = ['red-label', 'yellow-label', 'blue-label'];
      // 根据索引循环使用这三种颜色
      return colorClasses[index % 3];
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toGameN(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/GameN'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    getNotice(data){
      this.notice = data.notice;
      this.noticeText = data.notice;
      // 启动跑马灯动画
      this.$nextTick(() => {
        this.startMarquee();
      });
    },
    startMarquee() {
      const noticeText = this.$el.querySelector('.notice-text');
      if (!noticeText) return;
      
      // 重置动画
      noticeText.style.animation = 'none';
      setTimeout(() => {
        noticeText.style.animation = '';
      }, 10);
    },
    // getBanner(data){
    //   // this.banners = data.banners;
    // },
    toHomeDetail(item)
    {
      this.$router.push({path:'/homeDetail',query:{...item}})
    },
    showVipDialog() {
      this.showDialog = true;
    }
  },
  created() {
    this.getBasicConfig();
  }
}

</script>

<style lang='less' scoped>

.page{
  background-color: #F2F2F2 !important;
}

::v-deep .van-dialog{
  width: 6.4rem;
}
.home-container{
  height: calc(100% - 1.33333rem)
}

.home-container .home-scroll{
  width: calc(100% - .53333rem);
  height: calc(100% - 1.06667rem);
  margin: 0 auto;
  overflow-y: auto
}

.home-container .banner{
  height: 4.1984rem;
  position: relative
}

.home-container .banner .position-btn{
  position: absolute;
  top: 3.46667rem;
  right: .13333rem;
  z-index: 1000000;
  height: .53333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .26667rem;
  font-size: .34667rem;
  padding: 0 .24rem;
  word-break: keep-all;
  background: linear-gradient(#fde3ca,#e7b486);
  color: #8a5623
}

::v-deep .van-swipe__track{
  height: 4.1984rem;
}



.home-top-bar{
  width: 100%;
  height: 1.46667rem;
  padding: 0.2rem .4rem 0.2rem .26667rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
}

.home-top-bar img{
  height: 0.46667rem;
  -o-object-fit: contain;
  object-fit: contain;
}

.top-bar-icon {
  width: auto;
  max-width: 1.5rem;
  height: .8rem;
}

.home-top-bar span{
  color: #5b60df
}

.home-top-bar span:first-child {
  font-size: .34667rem
}

.home-top-bar span:nth-child(2) {
  font-size: .48rem;
  font-weight: 700
}

.home-top-bar span:nth-child(3) {
  font-size: .34667rem;
  color: transparent
}

.home-top-bar i{
  color: #fff
}

.notice-bar{
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border-radius: .13333rem;
  padding: .26rem .26667rem;
  margin-top: 0.53333rem;
  box-shadow: 0 0.04264rem 0.128rem rgba(0, 0, 0, .2);
  min-height: 0.8rem;
}

.notice-icon{
  font-size: .48rem;
  color: rgb(91, 96, 223);
  flex-shrink: 0;
  margin-right: .21333rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-wrapper {
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.notice-text{
  font-size: .37333rem;
  color: rgb(91, 96, 223);
  white-space: nowrap;
  animation: marquee 12s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes scroll-notice {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.swiper-container,.swiper-slide,.banner_img{
  height: 100%;
  width: 100%;
}

.home-container .home-scroll{
  width: 100%;
  height: calc(100% - 1.06667rem);
  margin: 0 auto;
  overflow-y: auto
}
.home-container .banner{
  height: 4.1984rem;
  position: relative
}

.home-container .banner .position-btn{
  position: absolute;
  top: 3.46667rem;
  right: .13333rem;
  z-index: 1000000;
  height: .53333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .26667rem;
  font-size: .34667rem;
  padding: 0 .24rem;
  word-break: keep-all;
  background: linear-gradient(#fde3ca,#e7b486);
  color: #8a5623
}
.banner .swiper-container .swiper-wrapper .swiper-slide .padding-b .img-wrapper{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.van-image--round {
  overflow: hidden;
  border-radius:0;
}


.describe {
  width: 100%;
  min-height: 5rem;
  border-radius: .26667rem;
  border: .02667rem solid #766350;
  margin: 0.3rem 0;
  margin-top: 1.26667rem;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: .21333rem;
  position: relative;
  overflow: hidden
}

.describe>ul {
  height: 2.13333rem;
  display: flex;
  align-items: flex-start
}

.describe>ul li {
  height: 100%
}

.describe>ul>li:first-child {
  width: 3.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-right: .08rem solid #e6b98a
}

.describe>ul>li:first-child div {
  color: #f3d3b8;
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .32rem
}

.describe>ul>li:first-child>div:first-child {
  font-size: .42667rem;
  font-weight: 700;
  height: 1.06667rem;
  text-align: center
}

.describe>ul>li:nth-child(2) {
  padding: 0 0 0 .13333rem;
  width: calc(100% - 3.2rem);
  font-size: .32rem;
  line-height: .66667rem;
  color: #fff
}

.describe>div {
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #e6b98a;
  line-height: .64rem;
  font-size: .32rem
}

.describe>div:nth-child(3) {
  font-size: .4rem;
  height: .8rem!important;
  font-weight: 700
}

.describe>div:nth-child(4) {
  width: 3.2rem;
  height: .8rem;
  background-color: #e6b98a;
  color: #fff;
  font-size: .48rem;
  border-radius: .4rem;
  margin: .13333rem auto;
  font-weight: 700
}

.describe:after,.describe:before {
  content: "";
  position: absolute;
  width: .53333rem;
  height: 6.66667rem;
  background: linear-gradient(90deg,rgba(74,70,70,.29),transparent);
  transform: rotate(50deg)
}

.describe:after {
  left: 50%
}

.movie-list-money{
    background: linear-gradient(90deg, #66f, #09f, #0f0, #f39, #66f);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent !important;
    animation: rainbow_animation-548f96a6 10s ease-in-out infinite;
    background-size: 400% 100%;
    font-weight: 700;
    position: relative;
    margin-right: 0.10664rem;
    background-position-x: 20.3595%;

}


.home-body{
  width: 100%;
  background-color: #fff;
}

.home-body>ul{
  height: .8rem;
  display: flex;
  overflow: auto
}

.home-body>ul>li{
  height: .53333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .26667rem;
  background: linear-gradient(90deg,#5b606c,#2b2b2b);
  font-size: .34667rem;
  padding: 0 .1rem;
  color: #fff;
  word-break: keep-all
}

.home-body>ul>li.active{
  background: linear-gradient(#fde3ca,#e7b486);
  color: #8a5623
}

.home-body>ul>li:not(:last-child) {
  margin-right: .13333rem
}

.home_app_name{
  font-size: .6rem !important;
  font-weight: 700;
}

.left-div-butn{
    background: linear-gradient(90deg, #df35ad, #4f1db5);
    color: #fff;
    border-radius: 0.10664rem;
    padding: 0.228rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.33rem;
    margin-top: 0.1rem;
}
  


.xuanfei{
  width: 100%;
  //height: 5rem;
  margin-bottom: .26667rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: .21333rem;
  position: relative;
  overflow: hidden
}

.xuanfei .left-div{
  width: 5.33333rem;
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0.77336rem 0 0.4rem;
  justify-content: center
}

.left-div-biaoqian{
  padding: 0 0.2rem;
  border-radius: .16667rem;
  line-height: .53333rem;
  text-align: center;
  margin-right: 0.064rem;
  font-size: .2rem;
  font-weight: 700;
  display: inline-block;
}

/* 默认标签样式 */
.left-div-biaoqian {
  background: linear-gradient(180deg,#e7caaf,#fff7ed);
  color: #8d5825;
}

/* 标签容器样式 */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.tag-item {
  display: inline-block;
  padding: 0.1rem 0.2rem;
  margin: 0.1rem 0.05rem;
  border-radius: 0.1rem; 
  background: linear-gradient(180deg,#e7caaf,#fff7ed);
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  min-width: 1.5rem;
  height: 0.8rem;
  line-height: 0.6rem;
}

/* 红色标签样式 */
.red-label {
  background: #fc2372;
  color: #fff;
}

/* 黄色标签样式 */
.yellow-label {
  background: #ff8b24;
  color: #fff;
}

/* 蓝色标签样式 */
.blue-label {
  background: #009ff9;
  color: #fff;
}


.xuanfei .right-div{
  width: 2.2rem;
  height: 100%;
  display: flex;
  justify-content: center
}

.xuanfei .right-div img{
  width: 2rem;
  height: 2rem;
  -o-object-fit: cover;
  object-fit: cover;
}

.xuanfei .sign-i{
  position: absolute;
  right: -.64rem;
  top: .16rem;
  background: #ff6056;
  font-size: .32rem;
  padding: .10667rem .64rem;
  font-style: normal;
  transform: rotate(45deg);
  color: #fff
}

.scroll-cmp {
  width: 100%;
  height: 100%;
  border-radius: 0.26667rem;
  border: 0.02667rem solid #766350;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.21333rem;
  position: relative;
  overflow: hidden;
}
.scroll-cmp .swper_item_detail{
  height: 25%;
}
.serverTerms {
  width: 100%;
  min-height: 4rem;
  border-radius: 0.26667rem;
  border: 0.02667rem solid #766350;
  margin: 0.26667rem 0;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  align-items: center;
  padding: 0.21333rem;
  position: relative;
  overflow: hidden;
}
.serverTerms ul li>div:first-child {
  font-size: .42667rem;
  color: #f3d3b8;
  font-weight: 700
}

.serverTerms ul li>div:nth-child(2) {
  font-size: .34667rem;
  color: #fff
}

.serverTerms ul>li:not(:last-child) {
  margin-bottom: .08rem
}

.serverTerms:after,.serverTerms:before {
  content: "";
  position: absolute;
  width: .53333rem;
  height: 6.66667rem;
  background: linear-gradient(90deg,rgba(74,70,70,.29),transparent);
  transform: rotate(50deg)
}

.serverTerms:after {
  left: 50%
}
.hot-game{
  display: flex;
  align-items: center;
  padding: 0.26667rem;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
  background-color: #fff;
  .hot-game-li{
    flex: 1;
    flex-basis: 25%;
    height: 1.70664rem;
    padding: 0.12264rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.64rem;
      height: 0.64rem;
    }
  }
  .hot-game-divider {
    width: 0.02667rem;
    height: 1.06667rem;
    background-color: #f2f2f2;
    margin: 0 0.13333rem;
  }
}

/* VIP Dialog Styles */
::v-deep .vip-dialog {
  border-radius: 0.4rem;
  overflow: hidden;
}

.dialog-content {
  padding: 0.53333rem;
  text-align: center;
  background: #fff;
}

.dialog-title {
  font-size: 0.48rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 0.4rem 0;
}

.dialog-text {
  font-size: 0.37333rem;
  color: #666;
  line-height: 1.6;
  margin: 0 0 0.53333rem 0;
}

.confirm-btn {
  width: 100%;
  height: 1.06667rem;
  border-radius: 0.53333rem;
  background: linear-gradient(90deg, #ff6034, #ee0a24);
  color: #fff;
  font-size: 0.32667rem;
  border: none;
}

::v-deep .confirm-btn .van-button__text {
  color: #fff;
}
</style>
